function addUIElements() {
	let $ = jQuery;
	var has_items = 0;
	var checked_items = $('input[type=checkbox]:checked').length;
	// reset filter bar
	// $( ".selected-filter-container" ).remove('.filter-button');
	$( ".filter-button:not(.clear-filter)").remove();

	$('.filter-container input[type=checkbox]:checked').each(function () {
		has_items = 1;

		var tax_value = (this.checked ? $(this).val() : "");
		var id = $(this).attr("id");
		var label = $(this).attr('data-display');
		let taxonomy = $(this).data( 'taxonomy' );
		$( ".selected-filter-container" ).prepend('<a class="filter-button taxonomy-button" href="#" data-taxid="'+tax_value+'" data-checkID="'+id+'" data-taxonomy="'+taxonomy+'">'+label+'</a>');

	});
	if (has_items){
		$('.clear-filter').removeClass('inactive');
	} else {
		$('.clear-filter').addClass('inactive');
	}

	$('.filter-container').removeClass('open');
}

jQuery( document ).ready(function($) {


	// burger
	$(".menu-toggle").click(function( event ) {
		event.preventDefault();
		$('.open-menu-containing-column').toggleClass('open');
		if ( $('.open-menu-containing-column').hasClass('open') ) {
			$(this).addClass('menu-close');
		} else {
			$(this).removeClass('menu-close');
		}
	});

	// search
    $(".search-trigger").click(function( event ) {
      event.preventDefault();
      $('.search-container').addClass('open');
    });

    $(".search-close").click(function( event) {
      event.preventDefault();
      $('.search-container').removeClass('open');
    });

	// open filters
	$('.filter-trigger').click(function(event) {
		event.preventDefault();
		$('.filter-container').toggleClass('open');
	});

	// close filters
	$('.filter-close').click(function(event) {
		event.preventDefault();
		$('.filter-container').removeClass('open');
	});

	// open / close panels inside filters
	$('.accordion-toggle').click(function(event) {
		event.preventDefault();
		// to do : this remove / add class collapsed to .accordion-toggle
		$(this).toggleClass('collapsed');
		var openTarget = $(this).attr('href');
		$(openTarget).toggleClass('collapse');
	});



	// get checked items and add them to filter bar.
	$('#apply-filters').click(function(event) {
		addUIElements();
	});


	$('.selected-filter-container').on( "click", '.filter-button', function( event ) {
		event.preventDefault();
		// remove this button from bar
		if (!$(this).hasClass('clear-filter')) {
			$(this).remove();		
			// TO DO :  remove checkbox
			$( "input[type=checkbox]#"+$(this).attr("data-checkid") ).prop( "checked", false );
		} else {
			// remove all buttons and set clear to inactive
			$( ".filter-button:not(.clear-filter)").remove();
			$('.clear-filter').addClass('inactive');
			// remove all checkboxes
			$('.filter-container input[type=checkbox]:checked').each(function () { 
				$( this).prop( "checked", false );
			});
		}
	});

	var checkExist = setInterval(function() {
		// don't bother if no donate box
		if ($('#ctct_form_0').length) {
			$("#email_address_0").attr("placeholder", "Enter your email address");
	      	clearInterval(checkExist);
	   }
	}, 100); // check every 100ms	

});

Handlebars.registerHelper('ifCond', function(v1, v2, options) {
	if(v1 === v2) {
		return options.fn(this);
	}
	return options.inverse(this);
});